// extracted by mini-css-extract-plugin
module.exports = {"item":"DialogItem_item__3x3Pv","active":"DialogItem_active__1Vp0j","dialogItemAva":"DialogItem_dialogItemAva__1KNmp"};